var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasAction)?_c('span',{attrs:{"title":_vm.getTranslation('actionType') + ': ' + _vm.getTranslation(_vm.action)}},[_vm._v(" "+_vm._s(_vm.getTranslation(_vm.action))+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }